import {Button, ButtonColor, ButtonVariant} from '@/components/common-components/v2/Button';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Dropdown, Input, Menu, Tooltip} from 'antd';
import {observer} from 'mobx-react-lite';
import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {faCaretDown, faCaretRight, faCheck} from '@fortawesome/pro-solid-svg-icons';
import {useStore} from '@/store/root-store';
import styles from './style.module.scss';
import {Search} from 'react-feather';
import {faPlus} from '@fortawesome/pro-solid-svg-icons';
import {SkeletonRingLoader} from '@/components/common-components/components/skeleton/ring-loader';
import {COLORS} from '@/components/common-components/v2/colors';
import {faCirclePlus, faCircleCheck} from '@fortawesome/pro-duotone-svg-icons';
import {LoadingOutlined} from '@ant-design/icons';
import {isPublicKeywordResearcherV2} from '@/utils/url';
import {debounce} from 'lodash';

interface Props {
  triggerNode?: any;
  addToBtn?: boolean;
  disabled?: boolean;
  keList?: any[];
  targetKeyword?: string;
  multipleKeyword?: any;
  buttonColor?: ButtonColor;
  buttonVariant?: ButtonVariant;
  setNewKeyword?: (data) => void;
  rankTrackerList?: any;
}
const {SubMenu} = Menu;
export const AddKeywordDropdownV2:React.FC<Props> = observer(({keList, triggerNode, addToBtn, disabled, targetKeyword, multipleKeyword, buttonColor, buttonVariant, setNewKeyword, rankTrackerList}) => {
  const checkPublicPages = isPublicKeywordResearcherV2();
  const {keywordResearcherV2: {loadingAddKeywordList, updatedKeywordListData, loadAddKeywordsList, setModaValue, setIsOpenModal, keywordRankTracker: {
    addTrackedKeywords,
    getListWithoutRepoll,
    setKrtSearchTerm,
    getList,
    // loadingList,
  }}} = useStore('');
  const {settings: {customer: {setAuthModal}}} = useStore('');

  const [timer, setTimer] = useState(null);
  const [isClose, setIsClose] = useState(false);
  const [loaderId, setLoaderId] = useState('');

  useEffect(()=>{
    if (typeof setNewKeyword == 'function') {
      if (multipleKeyword?.length) {
        setNewKeyword(multipleKeyword?.join('\n'));
      } else {
        setNewKeyword(targetKeyword);
      }
    }
  }, [isClose]);

  const onSearchHandler = event => {
    const value = event?.target?.value ?? '';
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimer(
      setTimeout(() => {
        loadAddKeywordsList(true, value);
      }, 600),
    );
  };
  function includesMulti(elements, inArray) {
    const unmatched = inArray.slice();
    for (const element of elements) {
      const matchIndex = unmatched.indexOf(element);
      if (matchIndex === -1) return false;
      unmatched.splice(matchIndex, 1);
    }
    return true;
  }

  const checkAllLists = [];
  if (keList?.length) {
    keList?.map(item => {
      item?.keywords?.map(z => {
        if (z) {
          checkAllLists.push(z);
        }
      });
    });
  }

  const checkAllKRTLists = [];
  if (rankTrackerList?.length) {
    rankTrackerList?.map(item => {
      item?.trackedKeywords?.map(z => {
        if (z) {
          checkAllKRTLists.push(z);
        }
      });
    });
  }

  const searchRankTracker = debounce(async val => {
    await setKrtSearchTerm(val);
    await getList(false, false, 0, false, 100);
  });

  const antIcon = <LoadingOutlined style={{fontSize: 13, color: '#7f4ead'}} spin />;

  return (
    <>
      {checkPublicPages ? <div onClick={() => setAuthModal(true, false)}>{
        triggerNode ? triggerNode : <ButtonStyled customBackground={buttonColor}
          color={buttonColor ? buttonColor : 'textGrayLight'}
          variant={buttonVariant ? buttonVariant : 'ghost'}
          background={!buttonColor && 'rgba(29, 29, 29, 0.1)'}>
          {checkAllLists?.includes(targetKeyword) ? <FontAwesomeIcon icon={faCircleCheck} style={{color: '#2AC155'}}/> : <FontAwesomeIcon icon={faCirclePlus}/>}&nbsp;&nbsp;Add to list&nbsp;&nbsp;<FontAwesomeIcon icon={faCaretDown}/></ButtonStyled>
      }</div> :
        <Dropdown
          overlayClassName={styles.addKeywordDropdownStyle}
          overlay={<Menu triggerSubMenuAction={'click'} expandIcon={<div></div>} style={{borderRadius: '8px'}}>
            <SubMenu key={`sub1`} popupClassName={styles.addKeywordMenuStyle} title={
              <FlexWrapperDropDown>
                <FlexWrapper>
                  {checkAllLists?.includes(targetKeyword) ? <FontAwesomeIcon icon={faCircleCheck} style={{color: '#2AC155'}}/> : <FontAwesomeIcon icon={faCirclePlus}/>}
                  <ButtonWrapper>Keyword List</ButtonWrapper>
                </FlexWrapper>
                <FontAwesomeIcon icon={faCaretRight} style={{marginRight: '12px'}}/>
              </FlexWrapperDropDown>
            }>
              <div style={{borderRadius: '8px'}}>
                <SearchContainer>
                  <Input
                    style={{marginTop: '3px', color: '#A3A4A4'}}
                    placeholder={'Search for a list...'}
                    onChange={onSearchHandler}
                    prefix={<Search width={15}/>}
                    bordered={false}
                  />
                </SearchContainer>
                <ListContainer>
                  {loadingAddKeywordList ? <SkeletonRingLoader /> : (keList?.length ? keList.map((item, index) => {
                    let added = false;
                    if (multipleKeyword?.length) {
                      added = includesMulti(multipleKeyword, item?.keywords);
                    } else {
                      added = item?.keywords?.includes(targetKeyword);
                    }
                    const prevList = item?.keywords;
                    return <ListItem key={`keyword_${index}`} onClick={async () => {
                      setLoaderId(`ke_id_${item?.id}`);
                      let updatedList = [];
                      if (added) {
                        if (multipleKeyword?.length) {
                          updatedList = item?.keywords?.filter(z => !multipleKeyword?.includes(z));
                        } else {
                          updatedList = item?.keywords?.filter(z => z !== targetKeyword);
                        }
                      } else {
                        if (multipleKeyword?.length) {
                          updatedList = [...prevList, ...multipleKeyword];
                        } else {
                          updatedList = [...prevList, `${targetKeyword}`];
                        }
                      }
                      if (updatedList?.length) {
                        const data = {'name': item?.name, 'keywords': updatedList, 'country_code': item?.countryCode};
                        await updatedKeywordListData(data, item?.id, true);
                        await loadAddKeywordsList(true);
                      } else {
                        setModaValue(true, item?.id);
                      }
                      setLoaderId('');
                    }}
                    style={{gap: '15px'}}
                    >
                      <Text>
                        <div style={{minWidth: '17px'}}>
                          {loaderId == `ke_id_${item?.id}` ? antIcon : (added ? <FontAwesomeIcon icon={faCheck} color='#1FAC47'/> : '')}
                        </div>
                        <div>{item?.name ?? '-'}</div>
                      </Text>
                      <Value>{item?.keywords?.length ?? ''}</Value>
                    </ListItem>;
                  }) : <div style={{color: '#A3A4A4', marginTop: '35px', textAlign: 'center'}}>No Data available</div>)}

                </ListContainer>
                <CreateListContainer>
                  <Menu.Item key={`menu_item_list`} style={{color: '#121212', cursor: 'pointer', height: '100%'}} onClick={()=>{
                    setIsClose(!isClose);
                    setIsOpenModal(true);
                  }}> <FontAwesomeIcon icon={faPlus} color='#121212'/>&nbsp; Create List</Menu.Item>
                </CreateListContainer>
              </div>
            </SubMenu>
            <SubMenu key={`sub2`} popupClassName={`${styles.addKeywordMenuStyle} ${styles.rankTrackerDropdown}`} title={<FlexWrapperDropDown>
              <FlexWrapper>
                {checkAllKRTLists?.includes(targetKeyword) ? <FontAwesomeIcon icon={faCircleCheck} style={{color: '#2AC155'}}/> : <FontAwesomeIcon icon={faCirclePlus}/>}
                <ButtonWrapper>Rank Tracker</ButtonWrapper>
              </FlexWrapper>
              <FontAwesomeIcon icon={faCaretRight} style={{marginRight: '12px'}}/>
            </FlexWrapperDropDown>}>
              <div style={{borderRadius: '8px'}}>
                <SearchContainer>
                  <Input
                    style={{marginTop: '3px', color: '#A3A4A4'}}
                    placeholder={'Search for a list...'}
                    onChange={e=>searchRankTracker(e.target.value)}
                    prefix={<Search width={15}/>}
                    bordered={false}
                  />
                </SearchContainer>
              </div>
              {(rankTrackerList?.length ? rankTrackerList?.map((item, index) => {
                const list = rankTrackerList?.filter(a => a?.id == item?.id);
                const allKeywordsList = [];
                list?.map(o => {
                  if (o?.trackedKeywords?.length) {
                    allKeywordsList.push(...o.trackedKeywords);
                  }
                });
                let added = false;
                if (multipleKeyword?.length) {
                  added = includesMulti(multipleKeyword, allKeywordsList);
                } else {
                  added = allKeywordsList?.includes(targetKeyword);
                }

                return <>
                  <SubMenu key={`sub${index+4}`} title={
                    <ListItem style={{background: 'transparent'}} key={`keyword_${index}`}>
                      <Text>
                        <div style={{minWidth: '17px'}}>
                          {loaderId == `krt_id_${item?.id}` ? antIcon : (added ? <FontAwesomeIcon icon={faCheck} color='#1FAC47'/> : '')}
                        </div>
                        <div>{item?.hostname ?? '-'}</div>
                      </Text>
                      <FontAwesomeIcon icon={faCaretRight}/>
                    </ListItem>
                  }>
                    <Wrapper>
                      <Menu>
                        {list?.map(z => {
                          let checkKeywordInProject = false;
                          if (multipleKeyword?.length) {
                            checkKeywordInProject = includesMulti(multipleKeyword, z?.trackedKeywords);
                          } else {
                            checkKeywordInProject = z?.trackedKeywords?.includes(targetKeyword);
                          }
                          return <Menu.Item key={`menu_item_${z?.id}`} style={{minWidth: '200px'}}>
                            <FlexWrapperDropDown style={{padding: '0'}}>
                              <FlexWrapper style={{marginLeft: '0'}}>
                                <div style={{minWidth: '11px'}}>
                                  {loaderId == `krt_id_${z?.id}` ? antIcon : (checkKeywordInProject ? <FontAwesomeIcon icon={faCheck} color='#1FAC47'/> : '')}
                                </div>
                                <div style={{display: 'flex'}} onClick={async ()=>{
                                  setLoaderId(`krt_id_${z?.id}`);
                                  if (Array.isArray(z?.trackedKeywords)) {
                                    const getKeywords = z?.trackedKeywords;
                                    let updatedList = [];
                                    if (checkKeywordInProject) {
                                      if (multipleKeyword?.length) {
                                        updatedList = getKeywords?.filter(z => !multipleKeyword?.includes(z));
                                      } else {
                                        updatedList = getKeywords?.filter(z => z !== targetKeyword);
                                      }
                                    } else {
                                      if (multipleKeyword?.length) {
                                        updatedList = [...getKeywords, ...multipleKeyword];
                                      } else {
                                        updatedList = [...getKeywords, `${targetKeyword}`];
                                      }
                                    }
                                    if (updatedList?.length) {
                                      await addTrackedKeywords(updatedList, z?.id);
                                      await getListWithoutRepoll(100);
                                    }
                                    setLoaderId('');
                                  }
                                }}>
                                  <div style={{color: '#121212'}}>{z?.preciseLocation}</div>&nbsp;
                                  <div style={{color: '#121212'}}>{`(${z?.countryCode? z?.countryCode?.toUpperCase(): 'worldWide'})`}</div>
                                </div>
                              </FlexWrapper>
                            </FlexWrapperDropDown >
                          </Menu.Item>;
                        })}
                      </Menu>
                    </Wrapper>
                  </SubMenu></>;
              }) : <div style={{color: '#A3A4A4', margin: '35px 0px', textAlign: 'center'}}>No Data available</div>)}


            </SubMenu>
          </Menu>}
          overlayStyle={{background: '#fff', width: '250px', borderRadius: '8px'}} trigger={['click']}>
          {triggerNode ? triggerNode : addToBtn ?
            <Tooltip title={disabled ? 'Select at least 1 keyword in the table to use the bulk feature or click on the small plus icons to the left of each keyword.' : ''}>
              <div>
                <StyledAddToBtn
                  customBackground={buttonColor}
                  color={buttonColor ? buttonColor : 'textGrayLight'}
                  variant={buttonVariant ? buttonVariant : 'ghost'}
                  background={!buttonColor && 'rgba(29, 29, 29, 0.1)'}
                  onClick={()=>setIsClose(!isClose)}
                  disabled={disabled}
                >
                  {<FontAwesomeIcon icon={faPlus}/>}&nbsp;&nbsp;Add to&nbsp;&nbsp;<FontAwesomeIcon icon={faCaretDown}/>
                </StyledAddToBtn>
              </div>
            </Tooltip> :
            <ButtonStyled
              customBackground={buttonColor}
              color={buttonColor ? buttonColor : 'textGrayLight'}
              variant={buttonVariant ? buttonVariant : 'ghost'}
              background={!buttonColor && 'rgba(29, 29, 29, 0.1)'}
              onClick={()=>setIsClose(!isClose)}>
              {checkAllLists?.includes(targetKeyword) ? <FontAwesomeIcon icon={faCircleCheck} style={{color: '#2AC155'}}/> : <FontAwesomeIcon icon={faCirclePlus}/>}&nbsp;&nbsp;Add to list&nbsp;&nbsp;<FontAwesomeIcon icon={faCaretDown}/>
            </ButtonStyled>}
        </Dropdown>}
    </>
  );
});

const ButtonStyled = styled(Button)<{customBackground?: ButtonColor}>`
  border: 1px solid ${p => p.customBackground ? COLORS[p.customBackground] : '#4E5156'};
  margin: 0 !important;
  height: 32px;
  display: flex;
  align-items: center;
`;
const StyledAddToBtn = styled(Button)<{customBackground?: ButtonColor}>`
border: 1px solid ${p => p.customBackground ? COLORS[p.customBackground] : '#4E5156'};
  margin: 0 !important;
  height: 32px;
  display: flex;
  align-items: center;
  margin: 15px 0px 15px 10px !important;
`;
const Wrapper= styled.div`
.ant-menu-item {
  &:hover {
  background: #2D6CCA1A;
  border-radius: 3px;
  }
}
.ant-menu-item-selected {
  background: #2D6CCA1A !important;
}
`;
const ListContainer = styled.div`
  max-height: 360px;
  min-height: 100px;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #F9F9FB;
  }

  ::-webkit-scrollbar-thumb {
    background: #4E515680;
    border-radius: 5px;
  }
`;

const ListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  min-height: 25px;
  cursor: pointer;
  &:hover {
    background-color: #2D6CCA1A;
  }
`;

const Text = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #121212;
  display: flex;
  align-items: center;
`;

const Value = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  text-align: right;
  color: #4E5156;
`;

const SearchContainer = styled.div`
  height: 38px;
  box-shadow: 0px 1px 0px #E8E8E8;
`;

const CreateListContainer = styled.div`
  height: 38px;
  background: #F9F9FB;
  box-shadow: 0px -1px 0px #E8E8E8;
  border-radius: 0 0 8px 8px;
`;
const FlexWrapperDropDown = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
`;
const FlexWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-left: 12px;
  align-items: center;
`;

const ButtonWrapper = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #121212;
`;

